import { Component, Inject, OnDestroy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GettyService} from '../../getty/getty.service';
import {ImagesService} from '../../shared/images.service';
import {SlideshowService} from '../slideshow.service';
@Component({
    selector: 'media-dialog',
    templateUrl: 'media-dialog.html',
})
export class MediaDialog implements OnDestroy {
    showImageDetails = false;
    showGettySearch = false;
    selectedIndex = 0;
    imagesChangeSubscription;
    imagesOpen = false;
    constructor( 
        @Inject(MAT_DIALOG_DATA) public data: any, 
        public slideshow: SlideshowService, 
        private ref: MatDialogRef<MediaDialog>, 
        public imagesService: ImagesService,
        public gettyService: GettyService
    ) {
        if( this.data.image ) {
            setTimeout(() => {
                this.showImageDetails = true;
            }, 200);
            
        } else {
            this.selectedIndex = this.data.removeEditTab ? 0 : 1;
            this.showGettySearch = true;
        }
        this.imagesChangeSubscription = this.imagesService.imagesChange.subscribe(images => {
            if( !images ) {
                return;
            }
            let i = images.length;
            let found = false;
            while(i--) {
                if( images[i].id == this.data.image.id ) {
                    found = true;
                    break;
                }
            }
            if( found === false ) {
                this.showImageDetails = false;
                this.data.image = null;
                if( this.data.removeEditTab ) {
                    return;
                }
                this.selectedIndex = 1;
                this.toggleTabContent();
            }
        });
    }
    done(event) {
        if( event.action === 'addToSlide' ) {
            this.ref.close(event.image);
        } else {
            this.ref.close();
        }
    }
    downloadAction(event) {
        switch(event.action) {
            case 'edit':
                this.data.image = event.image;
                if( this.data.removeEditTab ) {
                    return;
                }
                this.showImageDetails = false;
                this.selectedIndex = 0;
                this.showImageDetails = true;
                break;
            case 'addToSlide':
                this.done(event);
                break;
            default:
                break;
        }
    }
    toggleTabContent() {
        if( this.data.removeEditTab ) {
            return;
        }
        if( this.selectedIndex === 1 ) {
            this.showGettySearch = true;
        }
    }
    drop(e) {
        if( this.slideshow.locked ) {
            return;
        }
        if( e.event.dataTransfer.files.length === 0 ) {
            const text = e.event.dataTransfer.getData('Text');
            if( text ) {
                try {
                    const img = JSON.parse(text);
                    if( img ) {
                        this.gettyService.download(img, this.slideshow.assignment.id);
                    }
                } catch(error) {
                    alert('could not read file');
                    throw error;
                }
            }
        } else {
            this.imagesService.handleDropFiles(e.event.dataTransfer.files, this.slideshow.assignment, false);
        }
    }
    selectImage(e) {
        if( this.data.removeEditTab ) {
            return;
        }
        this.showImageDetails = false;
        this.data.image = e;
        if (this.data.adsTab && (!this.data.image.sizes.ad || this.data.image.sizes.ad.width !== 1200 || this.data.image.sizes.ad.height !== 628)) {
            this.imagesService.resetAdSize(this.data.image);
        }
        if (!this.data.image.sizes.feed_applenews) {
            this.imagesService.resetAppleNewsSize(this.data.image);
        }
        this.selectedIndex = 0;
        this.showImageDetails = true;
    }
    toggle(prop) {
        this[prop] = !this[prop];
    }
    ngOnDestroy() {
        if( this.imagesChangeSubscription ) {
            this.imagesChangeSubscription.unsubscribe();
        }
    }
}